import { useEffect } from 'react';

// Block tab close / hard refresh while `isDirty` is true.
//
// We previously also called `useBlocker` from react-router-dom to intercept
// in-app navigation, but `useBlocker` only works under a Data Router
// (createBrowserRouter + RouterProvider). The app uses the JSX-style
// <BrowserRouter>, so the hook threw on first render of every page that
// invoked this guard. Removed for now; will come back when we migrate the
// router. The `beforeunload` listener still covers the most dangerous case:
// closing the tab or hard-refreshing while edits are unsaved.
const useUnsavedChangesGuard = (isDirty) => {
  useEffect(() => {
    if (!isDirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
};

export default useUnsavedChangesGuard;
